export enum ContentType {
  Video,
  Photo,
  Text
};

export type Content = {
  type: ContentType;
  unlocked_after: number;
  id: string;
  url: string | null;
  title: string;
  author: string;
  content: string;
  scripture?: string;
  attachments?: string[];
  youtube_url?: string;
}

export type Video = Content;